import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class KerdesAsszociaciosListItemDto extends IdentifiableDto {
	constructor() {
		super();
        /** @type {string} */
		this.csorszam = null;
        /** @type {string} */
        this.leiras = null;
        /** @type {string} */
        this.magyarazat = null;

		this.leirasTetel = null;
	}

	/**
	 * @Parameter {string} csorszam
     * @Parameter {string} leiras
     * @Parameter {string} magyarazat
	 */
	setup(props) {
		super.setup(props);
		this.csorszam = props.csorszam;
        this.leiras = props.leiras;
        this.magyarazat = props.magyarazat;
		this.leirasTetel = props.leirasTetel;
		return this;
	}
}

export default KerdesAsszociaciosListItemDto;
